import { theme } from '@frontend/theme';
import { SpinningLoader } from '@frontend/design-system';

type Props = {
  isFetchingNextPage: boolean;
};

export const ListsFooterLoadingState = ({ isFetchingNextPage }: Props) => {
  if (isFetchingNextPage) {
    return (
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: theme.spacing(2),
        }}
      >
        <SpinningLoader />
      </div>
    );
  }

  return null;
};
